import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormValidationService} from '../../fork-common-controls/form-validation.service';
import {Utils} from '../../fork-common-controls/utils.service';

@Component({
  selector: 'ld-form-validation-error-message',
  templateUrl: 'form-validation-error-message.template.html',
  styleUrls: [ './form-validation-error-message.style.scss' ]
})
export class FormValidationErrorMessageComponent {

  @Input() public showErrorMessage = true;
  @Input() public controlId: string;
  @Input() public displayName: string;
  @Input() public errorDisplayLimit = 1; // default to only displaying one error message
  @Input() public formToValidate: FormGroup;
  // for some controls (e.g. ld-input-password), some errors won't be represented via the error message component,
  // in that case, pass in the errors that will get special treatment
  @Input() public errorsToIgnore: string[] = [];

  vowels: string[] = ['a', 'e', 'i', 'o', 'u'];
  vowelRuleExceptions: {} = {
    usage: true
  };

  constructor(private formValidationService: FormValidationService) {
  }

  formatErrorMessage(errorMessage): string {
    let ErrorMessage: string = errorMessage.replace(this.controlId, this.displayName);
    const firstWordOfDisplayName: string = this.displayName || ''
      .split(' ')[0]
      .toLowerCase();
    const firstWordStartsWithVowel: boolean = this.vowels.indexOf(firstWordOfDisplayName[0]) > -1;
    const isExceptionToRule: boolean = this.vowelRuleExceptions.hasOwnProperty(firstWordOfDisplayName);

    if (ErrorMessage.toLowerCase().startsWith('please enter a ') && firstWordStartsWithVowel && !isExceptionToRule ||
        ErrorMessage.toLowerCase().startsWith('please enter a ssn')) {
        ErrorMessage = ErrorMessage.substring(0, 14) + 'n' + ErrorMessage.substring(14);
    }

    return Utils.capitalizeSentence(ErrorMessage);
  }

  getErrors(): string[] {
    const control = this.formToValidate.controls[this.controlId];
    const errorList = new Array();
    if (!control.valid) {
      const errors = control.errors;
      const errorsLookup = this.formValidationService.errors;
      for (const error in errors) {
        if (errors.hasOwnProperty(error) &&
          !this.errorsToIgnore.includes(error)) {
          const errorPayload = errors[error];
          const errorMessageFunc = errorsLookup[error];

          if (!errorMessageFunc) {
            console.error(`no error lookup function for error "${error}" on controlId "${this.controlId}"`);
          }

          const errorMessage = errorMessageFunc(this.controlId, errorPayload);
          errorList.push(this.formatErrorMessage(errorMessage));
        }
      }
    }
    return errorList.length > 0 ? errorList : [];
  }

  getErrorsToDisplay(): string[] {
    const errorList = this.getErrors();
    while (errorList && errorList.length > this.errorDisplayLimit) {
      errorList.pop();
    }
    return errorList;
  }
}
